// hooks/useBusinessNavigation.ts
import { useNavigate } from "react-router-dom";
import { useBusinessSession } from "./useBusinessSession";
import { useBusinessRoutes } from "./useBusinessRoutes";

export const useBusinessNavigation = () => {
  const navigate = useNavigate();
  const { setSessionForBusiness } = useBusinessSession();
  const { getRouteForBusiness } = useBusinessRoutes();

  const navigateByBusiness = (business_type: string, employee?: string) => {
    setSessionForBusiness(business_type, employee);
    const route = getRouteForBusiness(business_type, employee);

    console.log(business_type);

    // ✅ Remove setTimeout — navigate instantly
    navigate(route, { replace: business_type === "Saloon" || business_type === "Grocery" });
  };

  return { navigateByBusiness };
};
